export default __webpack_public_path__ + "assets/layouts.eea87065efead428892786f40e7abf56.png";